export default "__VITE_ASSET__ArDrcxzv__"